<script setup>

import {storeToRefs} from "pinia";
import {onMounted} from "vue";
import {useRouter} from "vue-router";
import {useProductStore} from "@/stores/product.store";

const router = useRouter();
const productStore = useProductStore();
const {products} = storeToRefs(productStore);

const themeVars = {
  cardPadding: '10px 30px',
  cardFontSize: 'var(--van-font-size-lg)',
  cardDescColor: 'var(--van-text-color-3)',
};


onMounted(async () => {
  await productStore.fetchAll();
})

</script>

<template>
  <van-space direction="vertical" fill>
    <van-config-provider :theme-vars="themeVars">
      <van-card
        v-for="product in products"
        :key="product.id"
        :thumb="product.thumbnail_file_absolute_path"
        @click="router.push('/product/' + product.id)"
        :centered="true"
      >
        <template #title>
          <span class="category-title">
            {{ product.name }}
          </span>
        </template>
        <template #desc>
          <span class="category-description">
            {{ product.description }}
          </span>
        </template>
        <template #tags>
          <div class="category-tag-list">
            <van-tag
              v-for="category in product.categories"
              :key="category.id"
              plain
              round
              size="medium"
              type="primary"
              class="category-tag"
            >
              {{category.name}}
            </van-tag>
          </div>
        </template>
        <template #footer>
          <van-button
            round
            type="primary"
            icon="shopping-cart-o"
            size="small"
            :to="'product/' + product.id">
              Buy Now ${{product.amount}}
          </van-button>
        </template>
      </van-card>
    </van-config-provider>
  </van-space>
</template>
<style scoped>
.category-tag-list {
  margin-top: 10px;
  margin-left: 15px;
  margin-bottom: 10px;
}

.category-tag {
  margin-right: 3px;
}

.category-description {
  display: block;
  margin-top: 10px;
  color: var(--van-text-color-2);
  margin-left: 15px;
}

.category-title {
  margin-top: 10px;
  font-weight: bold;
  margin-left: 15px;
}

</style>
